module.exports = __webpack_public_path__ + "static/media/forward-orders-banner-updated-V2.c923d438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/forward-orders-banner-updated-V2.png
// module id = 1658
// module chunks = 0